import React from "react";

export default function IconButton(props) {
  return (
    <button {...props} className={`icon-button ${props.className ?? ""}`}>
      {props.children}
    </button>
  );
}
